import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import { toastr } from "react-redux-toastr";
import { API_URL } from "../../utils/constant";
import Pagination from "../Pagination/Pagination";
import $ from "jquery";

// Custom styles for enhanced table appearance
const tableStyles = `
  .enhanced-table {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    border: none;
  }
  
  .enhanced-table tbody tr {
    transition: all 0.3s ease;
    border-left: 4px solid transparent;
  }
  
  .enhanced-table tbody tr:hover {
    background-color: #f8f9fa;
    border-left-color: #667eea;
    transform: translateX(2px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  .enhanced-table tbody td {
    padding: 16px 12px;
    vertical-align: middle;
    border-top: 1px solid #e9ecef;
  }
  
  .enhanced-table .badge {
    font-weight: 500;
    letter-spacing: 0.3px;
  }
  
  .enhanced-table .btn-group-vertical .btn {
    border-radius: 6px;
    margin-bottom: 4px;
    transition: all 0.2s ease;
  }
  
  .enhanced-table .btn-group-vertical .btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }
  
  .scan-type-item {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 8px;
    margin-bottom: 8px;
    border-left: 3px solid #dee2e6;
  }
  
  .scan-type-item:hover {
    background: #e9ecef;
    border-left-color: #667eea;
  }
  
  .tag-badge {
    transition: all 0.2s ease;
  }
  
  .tag-badge:hover {
    transform: scale(1.05);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }
  
  .frequency-badge {
    font-weight: 600;
    text-transform: capitalize;
  }
  
  .empty-state {
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    border-radius: 12px;
    padding: 40px 20px;
  }
  
  .loading-state {
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    border-radius: 12px;
    padding: 40px 20px;
  }
`;

const SCAN_TYPES = [
  { 
    value: 'subDomainTakeoverScan', 
    label: 'Subdomain Takeover Scan',
    description: 'Detects vulnerable subdomains that could be hijacked',
    icon: 'fa-globe',
    color: 'badge-warning'
  },
  { 
    value: 'exploitCheckScan', 
    label: 'Exploit Check Scan',
    description: 'Identifies known vulnerabilities and exploits',
    icon: 'fa-bug',
    color: 'badge-danger'
  },
  { 
    value: 'misconfigurationScan', 
    label: 'Misconfiguration Scan',
    description: 'Finds security misconfigurations in services',
    icon: 'fa-cog',
    color: 'badge-info'
  },
  { 
    value: 'credentialBruteForceScan', 
    label: 'Credential Brute Force Scan',
    description: 'Tests weak credentials and authentication',
    icon: 'fa-key',
    color: 'badge-secondary'
  },
  { 
    value: 'malwareCredsScan', 
    label: 'Malware Credentials Scan',
    description: 'Checks for credentials exposed in malware samples',
    icon: 'fa-virus-slash',
    color: 'badge-danger'
  },
  { 
    value: 'leakedCredsScan', 
    label: 'Leaked Credentials Checker',
    description: 'Scans for leaked credentials in data breaches',
    icon: 'fa-user-secret',
    color: 'badge-warning'
  },
  { 
    value: 'portScan', 
    label: 'Port Scan',
    description: 'Discovers open ports and services',
    icon: 'fa-network-wired',
    color: 'badge-primary'
  },
  { 
    value: 'sshBruteForceScan', 
    label: 'SSH Brute Force Scan',
    description: 'Tests SSH service for weak authentication',
    icon: 'fa-terminal',
    color: 'badge-dark'
  },
  { 
    value: 'unAuthenticatedAPIs', 
    label: 'Unauthenticated APIs Scan',
    description: 'Discovers APIs that lack proper authentication controls',
    icon: 'fa-shield-alt',
    color: 'badge-warning'
  },
  { 
    value: 'secretsScanning', 
    label: 'Secrets Scanning',
    description: 'Detects hardcoded secrets, API keys, and sensitive data',
    icon: 'fa-search',
    color: 'badge-danger'
  }
];

const SCAN_FREQUENCIES = [
  { value: 'daily', label: 'Daily' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'bi-weekly', label: 'Bi-Weekly' },
  { value: 'monthly', label: 'Monthly' }
];

// Helper function to check if scan types require 'creds' targetType
const isCredentialScanType = (scanType) => {
  const credentialScanTypes = [
    'malwareCredsScan',
    'leakedCredsScan', 
    'credentialBruteForceScan'
  ];
  return credentialScanTypes.includes(scanType);
};

// Helper function to check if any selected scan type is credential-based
const hasCredentialScanTypes = (scanTypes) => {
  return scanTypes.some(scanType => isCredentialScanType(scanType));
};

const RedTeamingSimulationsNew = () => {
  // List view state
  const [simulations, setSimulations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    limit: 10,
    hasNextPage: false,
    hasPrevPage: false
  });
  const [sorting, setSorting] = useState({
    sortBy: 'createdAt',
    sortOrder: 'desc'
  });

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [selectedSimulation, setSelectedSimulation] = useState(null);
  const [formData, setFormData] = useState({
    stimulationSchedulerName: '',
    targets: [{ target: '', targetType: 'tag' }],
    scanTypes: [''],  // Initialize with one empty scan type for dropdown
    scanFrequency: 'daily',
    nextScanAt: new Date().toISOString().split('T')[0]
  });
  const [modalLoading, setModalLoading] = useState(false);
  const [tags, setTags] = useState([]);
  const [tagsLoading, setTagsLoading] = useState(false);
  const [searchTimeout, setSearchTimeout] = useState(null);

  const { orgId } = useParams();
  const id = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  });

  const handleApiError = (error, defaultMessage = "An error occurred") => {
    // console.error removed
    let message = defaultMessage;

    if (error.response) {
      message = error.response.data?.message || error.response.data?.userMessage || message;
    } else if (error.message) {
      message = error.message;
    }

    toastr.error('Error', message);
  };

  const fetchSimulations = async (page = 1) => {
    try {
      setLoading(true);
      if (!id) {
        toastr.error('Error', 'Organisation ID not found');
        return;
      }

      const session = localStorage.getItem("session");
      const response = await axios.get(
        `${API_URL}/organisations/${id}/cart/stimulations`,
        {
          params: {
            limit: pagination.limit,
            page: page,
            sortBy: sorting.sortBy,
            sortOrder: sorting.sortOrder
          },
          headers: { Authorization: `Bearer ${session}` }
        }
      );

      if (response.data?.success && response.data?.data) {
        setSimulations(response.data.data.stimulations || []);
        setPagination(response.data.data.pagination || {
          currentPage: 1,
          totalPages: 1,
          totalCount: 0,
          limit: 10,
          hasNextPage: false,
          hasPrevPage: false
        });
      }
    } catch (error) {
      handleApiError(error, "Failed to fetch simulations");
      setSimulations([]);
      setPagination({
        currentPage: 1,
        totalPages: 1,
        totalCount: 0,
        limit: 10,
        hasNextPage: false,
        hasPrevPage: false
      });
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    fetchSimulations(page);
  };

  const handleCreateClick = () => {
    setSelectedSimulation(null);
    setFormData({
      stimulationSchedulerName: '',
      targets: [{ target: '', targetType: 'tag' }],
      scanTypes: [''],  // Initialize with one empty scan type for dropdown
      scanFrequency: 'daily',
      nextScanAt: new Date().toISOString().split('T')[0]
    });
    setShowModal(true);
  };

  const handleEditClick = (simulation) => {
    setSelectedSimulation(simulation);
    
    // Check if ALL scan types are credential-based
    const nonEmptyScans = (simulation.scanTypes || []).filter(scanType => scanType !== '');
    const hasOnlyCredScans = nonEmptyScans.length > 0 && 
      nonEmptyScans.every(scanType => isCredentialScanType(scanType));
    
    let targets;
    if (hasOnlyCredScans) {
      // For pure credential scans, use a default creds target if no targets exist
      targets = simulation.targets && simulation.targets.length > 0 
        ? simulation.targets.map(target => ({
            target: typeof target === 'string' ? target : target.target,
            targetType: 'creds'
          }))
        : [{ target: 'default-creds', targetType: 'creds' }];
    } else {
      // For regular scans or mixed scans, handle the target structure normally with 'tag'
      targets = simulation.targets.map(target => {
        if (typeof target === 'string') {
          return { target: target, targetType: 'tag' };
        } else if (target.target) {
          return { target: target.target, targetType: target.targetType === 'creds' ? 'tag' : (target.targetType || 'tag') };
        } else {
          return { target: target, targetType: 'tag' };
        }
      });
    }
    
    setFormData({
      stimulationSchedulerName: simulation.stimulationSchedulerName,
      targets: targets,
      scanTypes: simulation.scanTypes.length > 0 ? simulation.scanTypes : [''],
      scanFrequency: simulation.scanFrequency,
      nextScanAt: new Date(simulation.nextScanAt).toISOString().split('T')[0]
    });
    setShowModal(true);
  };

  const handleDeleteClick = async (simulation) => {
    $.confirm({
      title: "Are you sure?",
      content: "Do you really want to delete this simulation?",
      type: "red",
      buttons: {
        ok: {
          text: "Delete",
          btnClass: "btn-danger",
          keys: ["enter"],
          action: async function () {
            try {
              const session = localStorage.getItem("session");
              const response = await axios.delete(
                `${API_URL}/organisations/${id}/cart/stimulations/${simulation._id}`,
                {
                  headers: { Authorization: `Bearer ${session}` }
                }
              );

              if (response.data.success) {
                toastr.success('Success', 'Simulation deleted successfully');
                fetchSimulations(pagination.currentPage);
              }
            } catch (error) {
              handleApiError(error, 'Failed to delete simulation');
            }
          },
        },
        cancel: function () {},
      },
    });
  };

  const handleModalSubmit = async (e) => {
    e.preventDefault();
    setModalLoading(true);

    try {
      // Check if ALL scan types are credential-based
      const allCredentialScans = formData.scanTypes.length > 0 && 
        formData.scanTypes.every(scanType => scanType === '' || isCredentialScanType(scanType));
      
      // Only filter out empty scan types for this check
      const nonEmptyScans = formData.scanTypes.filter(scanType => scanType !== '');
      const hasOnlyCredScans = nonEmptyScans.length > 0 && 
        nonEmptyScans.every(scanType => isCredentialScanType(scanType));
      
      let targets;
      if (hasOnlyCredScans) {
        // Only if ALL selected scan types are credential-based, use default creds target
        targets = [{ target: 'default-creds', targetType: 'creds' }];
      } else {
        // If any scan type is NOT credential-based, use the actual tag targets
        targets = formData.targets.map(target => ({
          ...target,
          targetType: 'tag'
        }));
      }
      
      const validatedFormData = {
        ...formData,
        targets: targets
      };


      const session = localStorage.getItem("session");
      const url = selectedSimulation
        ? `${API_URL}/organisations/${id}/cart/stimulations/${selectedSimulation._id}`
        : `${API_URL}/organisations/${id}/cart/stimulations`;

      const method = selectedSimulation ? 'put' : 'post';

      const response = await axios[method](url, validatedFormData, {
        headers: { Authorization: `Bearer ${session}` }
      });

      if (response.data.success) {
        toastr.success('Success', `Simulation ${selectedSimulation ? 'updated' : 'created'} successfully`);
        fetchSimulations(pagination.currentPage);
        setShowModal(false);
      }
    } catch (error) {
      handleApiError(error, 'Failed to save simulation');
    } finally {
      setModalLoading(false);
    }
  };

  const handleTagChange = (index, field, value) => {
    const newTargets = [...formData.targets];
    newTargets[index] = { ...newTargets[index], [field]: value };
    
    // Set targetType based on selected scan types
    if (field === 'target') {
      const nonEmptyScans = formData.scanTypes.filter(scanType => scanType !== '');
      const hasOnlyCredScans = nonEmptyScans.length > 0 && 
        nonEmptyScans.every(scanType => isCredentialScanType(scanType));
      newTargets[index].targetType = hasOnlyCredScans ? 'creds' : 'tag';
    }
    
    setFormData({ ...formData, targets: newTargets });
  };

  const addTag = () => {
    const nonEmptyScans = formData.scanTypes.filter(scanType => scanType !== '');
    const hasOnlyCredScans = nonEmptyScans.length > 0 && 
      nonEmptyScans.every(scanType => isCredentialScanType(scanType));
    const targetType = hasOnlyCredScans ? 'creds' : 'tag';
    
    setFormData({
      ...formData,
      targets: [...formData.targets, { target: '', targetType: targetType }]
    });
  };

  const removeTag = (index) => {
    const newTargets = formData.targets.filter((_, i) => i !== index);
    setFormData({ ...formData, targets: newTargets });
  };

  const handleScanTypeChange = (index, value) => {
    const newScanTypes = [...formData.scanTypes];
    newScanTypes[index] = value;
    
    // Check if ALL non-empty scan types are credential-based
    const nonEmptyScans = newScanTypes.filter(scanType => scanType !== '');
    const hasOnlyCredScans = nonEmptyScans.length > 0 && 
      nonEmptyScans.every(scanType => isCredentialScanType(scanType));
    
    const targetType = hasOnlyCredScans ? 'creds' : 'tag';
    
    const updatedTargets = formData.targets.map(target => ({
      ...target,
      targetType: targetType
    }));
    
    setFormData({ 
      ...formData, 
      scanTypes: newScanTypes,
      targets: updatedTargets
    });
  };

  const addScanType = () => {
    setFormData({
      ...formData,
      scanTypes: [...formData.scanTypes, '']
    });
  };

  const removeScanType = (index) => {
    const newScanTypes = formData.scanTypes.filter((_, i) => i !== index);
    setFormData({ ...formData, scanTypes: newScanTypes });
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const fetchTags = async (searchTerm = '') => {
    try {
      setTagsLoading(true);
      if (!id) {
        toastr.error('Error', 'Organisation ID not found');
        return;
      }

      const session = localStorage.getItem("session");
      const response = await axios.get(
        `${API_URL}/digital-inventory/${id}/tags?search=${searchTerm}`,
        {
          headers: { Authorization: `Bearer ${session}` }
        }
      );
      
      if (response.data && response.data.data) {
        setTags(response.data.data);
      } else {
        setTags([]);
      }
    } catch (error) {
      // console.error removed
      setTags([]);
    } finally {
      setTagsLoading(false);
    }
  };

  const handleTagSearch = (searchTerm) => {
    // Clear existing timeout
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }
    
    // Set new timeout for debounced search
    const timeout = setTimeout(() => {
      fetchTags(searchTerm);
    }, 300);
    
    setSearchTimeout(timeout);
  };

  useEffect(() => {
    if (id) {
      fetchSimulations(pagination.currentPage);
    }
  }, [id]);

  useEffect(() => {
    if (showModal) {
      fetchTags();
    }
  }, [showModal]);

  useEffect(() => {
    // Cleanup timeout on unmount
    return () => {
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }
    };
  }, []);

  return (
    <div className="container-fluid">
      <style>{tableStyles}</style>
      <div className="block-header">
        <div className="row clearfix">
          <div className="col-md-6 col-sm-12">
            <h1 className="welcome-text">Red Teaming Simulations</h1>
            <nav aria-label="breadcrumb" className="mt-1">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/" className="welcome-textSmall">Home</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/red-teaming/dashboard">Red Teaming Dashboard</Link>
                </li>
                <li
                  className="breadcrumb-item active"
                  aria-current="page"
                  style={{ color: "white" }}
                >
                  Simulations
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="card enhanced-table">
            <div className="card-body p-0">
              <div className="row mb-3 p-3">
                <div className="col-md-6">
                  <h4 className="header-title mb-0">
                    <i className="fa fa-shield-alt mr-2 text-primary"></i>
                    Simulations
                  </h4>
                  <small className="text-muted">Manage your red teaming simulation schedules</small>
                </div>
                <div className="col-md-6 text-right">
                  <button className="btn btn-primary btn-lg" onClick={handleCreateClick}>
                    <i className="fa fa-plus mr-2"></i>
                    New Simulation
                  </button>
                </div>
              </div>

              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <thead>
                    <tr>
                      <th className="text-center" style={{width: '60px'}}>#</th>
                      <th style={{minWidth: '200px'}}>Name</th>
                      <th style={{minWidth: '250px'}}>Tags</th>
                      <th style={{minWidth: '300px'}}>Scan Types</th>
                      <th style={{width: '120px'}}>Frequency</th>
                      <th style={{width: '150px'}}>Next Scan</th>
                      <th style={{width: '150px'}}>Last Scanned</th>
                      <th style={{width: '120px'}}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="8" className="text-center py-5">
                          <div className="loading-state">
                            <div className="d-flex flex-column align-items-center">
                              <div className="spinner-border text-primary mb-3" role="status" style={{width: '3rem', height: '3rem'}}>
                                <span className="sr-only">Loading...</span>
                              </div>
                              <span className="text-muted font-weight-bold">Loading simulations...</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ) : simulations.length > 0 ? (
                      simulations.map((simulation, index) => (
                        <tr key={simulation._id} className="align-middle">
                          <td className="text-center">
                            <span className="badge badge-light badge-pill font-weight-bold">
                              {(pagination.currentPage - 1) * pagination.limit + index + 1}
                            </span>
                          </td>
                          <td>
                            <div className="d-flex align-items-center">
                              <div className="mr-3">
                                <i className="fa fa-shield-alt fa-2x text-primary"></i>
                              </div>
                              <div>
                                <h6 className="mb-0 font-weight-bold text-dark">
                                  {simulation.stimulationSchedulerName}
                                </h6>
                                <small className="text-muted">
                                  ID: {simulation._id.slice(-8)}
                                </small>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex flex-wrap gap-1">
                              {simulation.targets.map((target, targetIndex) => (
                                <span 
                                  key={`${target.target}-${targetIndex}`} 
                                  className="badge badge-info badge-pill px-3 py-2 tag-badge"
                                  style={{fontSize: '0.85rem'}}
                                >
                                  <i className="fa fa-tag mr-1"></i>
                                  {target.target}
                                </span>
                              ))}
                            </div>
                          </td>
                          <td>
                            <div className="d-flex flex-column gap-2">
                              {simulation.scanTypes.map((type, typeIndex) => {
                                const scanType = SCAN_TYPES.find(st => st.value === type);
                                return (
                                  <div key={`${type}-${typeIndex}`} className="scan-type-item">
                                    <div className="d-flex align-items-center">
                                      <span className={`badge ${scanType ? scanType.color : 'badge-secondary'} badge-pill px-3 py-2 mr-3`} style={{minWidth: '45px'}}>
                                        <i className={`fa ${scanType ? scanType.icon : 'fa-question'} mr-1`}></i>
                                      </span>
                                      <div className="flex-grow-1">
                                        <div className="font-weight-bold text-dark" style={{fontSize: '0.9rem'}}>
                                          {scanType ? scanType.label : type}
                                        </div>
                                        {scanType && (
                                          <small className="text-muted d-block" style={{fontSize: '0.75rem', lineHeight: '1.3'}}>
                                            {scanType.description}
                                          </small>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </td>
                          <td className="text-center">
                            <span className={`badge badge-pill px-3 py-2 frequency-badge ${
                              simulation.scanFrequency === 'daily' ? 'badge-success' :
                              simulation.scanFrequency === 'weekly' ? 'badge-info' :
                              simulation.scanFrequency === 'bi-weekly' ? 'badge-warning' :
                              'badge-secondary'
                            }`}>
                              <i className={`fa mr-1 ${
                                simulation.scanFrequency === 'daily' ? 'fa-calendar-day' :
                                simulation.scanFrequency === 'weekly' ? 'fa-calendar-week' :
                                simulation.scanFrequency === 'bi-weekly' ? 'fa-calendar-alt' :
                                'fa-calendar'
                              }`}></i>
                              {simulation.scanFrequency}
                            </span>
                          </td>
                          <td>
                            <div className="text-center">
                              <div className="font-weight-bold text-dark">
                                {new Date(simulation.nextScanAt).toLocaleDateString()}
                              </div>
                              <small className="text-muted">
                                {new Date(simulation.nextScanAt).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
                              </small>
                            </div>
                          </td>
                          <td>
                            <div className="text-center">
                              {simulation.lastScannedAt ? (
                                <>
                                  <div className="font-weight-bold text-success">
                                    {new Date(simulation.lastScannedAt).toLocaleDateString()}
                                  </div>
                                  <small className="text-muted">
                                    {new Date(simulation.lastScannedAt).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
                                  </small>
                                </>
                              ) : (
                                <span className="badge badge-light badge-pill px-3 py-2">
                                  <i className="fa fa-clock-o mr-1"></i>
                                  Never
                                </span>
                              )}
                            </div>
                          </td>
                          <td>
                            <div className="btn-group-vertical btn-group-sm w-100">
                              <button
                                type="button"
                                className="btn btn-outline-primary btn-sm mb-1"
                                onClick={() => handleEditClick(simulation)}
                                title="Edit simulation"
                              >
                                <i className="fa fa-edit mr-1"></i>
                                Edit
                              </button>
                              <button
                                type="button"
                                className="btn btn-outline-danger btn-sm"
                                onClick={() => handleDeleteClick(simulation)}
                                title="Delete simulation"
                              >
                                <i className="fa fa-trash mr-1"></i>
                                Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center py-5">
                          <div className="empty-state">
                            <div className="d-flex flex-column align-items-center">
                              <i className="fa fa-inbox fa-3x text-muted mb-3"></i>
                              <h5 className="text-muted mb-2">No simulations found</h5>
                              <p className="text-muted mb-0">Create your first simulation to get started</p>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              {pagination.totalCount > 0 && (
                <div className="row mt-3">
                  <div className="col-md-12 d-flex justify-content-end">
                    <div className="dataTables_paginate">
                      <Pagination
                        className="pagination-bar"
                        currentPage={pagination.currentPage}
                        totalCount={pagination.totalCount}
                        pageSize={pagination.limit}
                        onPageChange={handlePageChange}
                      />
                    </div>
                  </div>
                </div>
              )}

              {/* Modal */}


              {/* Modal backdrop */}
              {showModal && (
                <div className="modal-backdrop fade show"></div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className={`modal fade Form-Wizard-modal ${showModal ? "d-block show" : ""}`}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {selectedSimulation ? 'Edit Simulation' : 'Create New Simulation'}
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={handleCloseModal}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <form onSubmit={handleModalSubmit}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <h6>Simulation Name</h6>
                      <input
                        type="text"
                        className="form-control"
                        value={formData.stimulationSchedulerName}
                        onChange={(e) =>
                          setFormData({ ...formData, stimulationSchedulerName: e.target.value })
                        }
                        required
                      />
                    </div>

                    {(() => {
                      // Show tag selection if any scan type is NOT credential-based
                      const nonEmptyScans = formData.scanTypes.filter(scanType => scanType !== '');
                      const hasOnlyCredScans = nonEmptyScans.length > 0 && 
                        nonEmptyScans.every(scanType => isCredentialScanType(scanType));
                      return !hasOnlyCredScans;
                    })() ? (
                      <div className="form-group">
                        <h6>Tags</h6>
                        <div className="mb-3">
                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search tags..."
                              onChange={(e) => handleTagSearch(e.target.value)}
                            />
                            <div className="input-group-append">
                              <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={() => fetchTags()}
                                disabled={tagsLoading}
                                title="Refresh tags"
                              >
                                <i className={`fa ${tagsLoading ? 'fa-spinner fa-spin' : 'fa-refresh'}`}></i>
                              </button>
                              <span className="input-group-text">
                                <i className="fa fa-search"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="table-responsive mb-3">
                          <table className="table table-bordered table-sm">
                            <thead>
                              <tr>
                                <th>Tags</th>
                                <th width="100">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {formData.targets.map((target, index) => (
                                <tr key={index}>
                                  <td>
                                    <select
                                      className="form-control form-control-sm"
                                      value={target.target}
                                      onChange={(e) =>
                                        handleTagChange(index, 'target', e.target.value)
                                      }
                                      required
                                    >
                                      <option value="">Select a tag</option>
                                      {tagsLoading ? (
                                        <option value="" disabled>Loading tags...</option>
                                      ) : tags.length === 0 ? (
                                        <option value="" disabled>No tags found</option>
                                      ) : (
                                        tags.map((tag, tagIndex) => (
                                          <option key={tagIndex} value={tag}>
                                            {tag}
                                          </option>
                                        ))
                                      )}
                                    </select>
                                  </td>
                                  <td className="text-center">
                                    <button
                                      type="button"
                                      className="btn btn-danger btn-sm"
                                      onClick={() => removeTag(index)}
                                      disabled={formData.targets.length === 1}
                                    >
                                      <i className="fa fa-trash"></i>
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                        <button
                          type="button"
                          className="btn btn-secondary btn-sm"
                          onClick={addTag}
                        >
                          <i className="fa fa-plus mr-1"></i>
                          Add Tag
                        </button>
                      </div>
                    ) : (
                      <div className="form-group">
                        <h6>Target Configuration</h6>
                        <div className="alert alert-info">
                          <i className="fa fa-info-circle mr-2"></i>
                          You have selected only credential-based scans (Malware Credentials, Leaked Credentials Checker, and/or Credential Brute Force). 
                          The target type is automatically set to <strong>"creds"</strong>. No tag selection is required.
                        </div>
                      </div>
                    )}

                    <div className="form-group">
                      <h6>Scan Types</h6>
                      <div className="table-responsive mb-3">
                        <table className="table table-bordered table-sm">
                          <thead>
                            <tr>
                              <th>Scan Type</th>
                              <th width="100">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {formData.scanTypes.map((scanType, index) => (
                              <tr key={index}>
                                <td>
                                  <select
                                    className="form-control form-control-sm"
                                    value={scanType}
                                    onChange={(e) => handleScanTypeChange(index, e.target.value)}
                                    required
                                  >
                                    <option value="">Select scan type</option>
                                    {SCAN_TYPES.map((type) => (
                                      <option key={type.value} value={type.value}>
                                        {type.label}
                                      </option>
                                    ))}
                                  </select>
                                </td>
                                <td className="text-center">
                                  <button
                                    type="button"
                                    className="btn btn-danger btn-sm"
                                    onClick={() => removeScanType(index)}
                                    disabled={formData.scanTypes.length === 1}
                                  >
                                    <i className="fa fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <button
                        type="button"
                        className="btn btn-secondary btn-sm"
                        onClick={addScanType}
                      >
                        <i className="fa fa-plus mr-1"></i>
                        Add Scan Type
                      </button>
                    </div>

                    <div className="form-group">
                      <h6>Scan Frequency</h6>
                      <select
                        className="form-control"
                        value={formData.scanFrequency}
                        onChange={(e) =>
                          setFormData({ ...formData, scanFrequency: e.target.value })
                        }
                        required
                      >
                        {SCAN_FREQUENCIES.map((frequency) => (
                          <option key={frequency.value} value={frequency.value}>
                            {frequency.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="form-group">
                      <h6>Next Scan Date</h6>
                      <input
                        type="date"
                        className="form-control"
                        value={formData.nextScanAt}
                        onChange={(e) =>
                          setFormData({ ...formData, nextScanAt: e.target.value })
                        }
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCloseModal}
                  disabled={modalLoading}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary" disabled={modalLoading}>
                  {modalLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm mr-1"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Saving...
                    </>
                  ) : selectedSimulation ? (
                    'Update Simulation'
                  ) : (
                    'Create Simulation'
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RedTeamingSimulationsNew; 